const DEFAULT_VERSION = '0000000';

function getVersion(UA) {
  // format BMoneyiOS/0240000 blbeta iPhone5,2 iOS/10_1 CFNetwork/808.3 Darwin/16.3.0
  // format BMoneyAndroid/4045200 blbeta Dalvik/2.1.0 (Linux; U; Android 6.0.1; vivo 1610 Build/MMB29M)

  const regexMatch = UA.match(/(bmoneyios|bmoneyandroid)\/\d{4,10} /i);
  return regexMatch ? regexMatch[0].split('/')[1] : regexMatch;
}

export function getAppVersion(UA) {
  return Number(getVersion(UA)) || Number(DEFAULT_VERSION);
}

function getIosFormattedAppVersion(appVersion) {
  // 3 patch, 2 minor, 2 major
  let version = appVersion; // 0162121
  const major = Math.floor(version / 100000); // major = 1
  version %= 100000; // 62121
  const minor = Math.floor(version / 1000); // minor = 62
  const patch = version % 1000; // patch = 121

  return `${major}.${minor}.${patch}`; // 1.62.121
}

function getAndroidFormattedAppVersion(appVersion) {
  // 3 patch, 3 minor, 1 Major
  let version = appVersion; // 0162121
  const major = Math.floor(version / 1000000); // major = 0
  version %= 1000000; // 162121
  const minor = Math.floor(version / 1000); // minor = 162
  const patch = version % 1000; // patch = 121

  return `${major}.${minor}.${patch}`; // 0.162.121
}

/* istanbul ignore next */
export const USER_AGENT = (global && global.navigator && global.navigator.userAgent) || '';
export const APP_VERSION = getAppVersion(USER_AGENT);
export const IS_BMONEY_APP = /(bmoneyandroid|bmoneyios)/i.test(USER_AGENT);
export const IS_IOS = /bmoneyios/i.test(USER_AGENT);
export const IS_ANDROID = /bmoneyandroid/i.test(USER_AGENT);
export function getFormattedAppVersion(UA) {
  const appVersion = getAppVersion(UA);
  if (/bmoneyios/i.test(UA)) {
    return getIosFormattedAppVersion(appVersion);
  }

  return getAndroidFormattedAppVersion(appVersion);
}
export const FORMATTED_APP_VERSION = getFormattedAppVersion(USER_AGENT);

export default {};
